import { Stage } from 'modules/case-tracking/types/case-tracking.enums';
import { InstructionCategory, Status } from 'modules/case-tracking/types/filtering/filtering.enums';

export const caseStatus: Record<InstructionCategory, Record<Stage, Status[]>> = {
  // List of all available New Business Statusses
  [InstructionCategory.NewBusiness]: {
    [Stage.Stage1]: [Status.instructionReceived],
    [Stage.Stage2]: [
      Status.requirementVerification,
      Status.requirementRequested,
      Status.requirementValidation
    ],
    [Stage.Stage3]: [
      Status.processingApplication,
      Status.bankDetailSent,
      Status.pendingContribution
    ],
    [Stage.Stage4]: [Status.instructionFinalised, Status.purchasingUnits, Status.completed],
    [Stage.Cancelled]: [Status.instructionCancelled, Status.policyCancelled]
  },
  // List of all available Client Maintenance Statusses
  [InstructionCategory.ClientMaintenance]: {
    [Stage.Stage1]: [Status.instructionReceived],
    [Stage.Stage2]: [
      Status.requirementVerification,
      Status.requirementRequested,
      Status.requirementValidation
    ],
    [Stage.Stage3]: [Status.processingInstruction],
    [Stage.Stage4]: [Status.completed],
    [Stage.Cancelled]: [Status.instructionCancelled]
  },
  // List of all available Policy Maintenance Statusses
  [InstructionCategory.PlanMaintenance]: {
    [Stage.Stage1]: [Status.instructionReceived],
    [Stage.Stage2]: [
      Status.requirementVerification,
      Status.requirementRequested,
      Status.requirementValidation
    ],
    [Stage.Stage3]: [Status.processingInstruction],
    [Stage.Stage4]: [Status.completed],
    [Stage.Cancelled]: [Status.instructionCancelled]
  }
};
